import axios from "axios";

// Konfigurer Axios-instansen
const apiClient = axios.create({
  baseURL: "https://shop.perhagen.no", // Skriv inn backend-serverens base URL
});

// Legg til et interceptor for å legge til token i headeren
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken"); // Hent token fra localStorage
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

export default apiClient;